export enum EmailLocale {
  English = "en",
  French = "fr",
  German = "de",
  Italian = "it",
  Dutch = "nl",
}

export type EmailBlockType =
  "text" | "code" | "button" | "heading" | "list" | "table";

export interface IEmailTableRow {
  label: string;
  value: string;
  href?: string;
}

export interface IEmailBlock {
  type: EmailBlockType;
  text?: string;
  href?: string;
  ordered?: boolean;
  items?: string[];
  rows?: IEmailTableRow[];
}

export interface IEmailLocaleContent {
  subject: string;
  blocks: IEmailBlock[];
}

export interface IEmailTemplateSummary {
  slug: string;
  locales: string[];
  params: string[];
}

export interface IEmailTemplateDetail {
  slug: string;
  name: string;
  params: string[];
  locales: string[];
  publishedVersion: number;
  published: Record<string, IEmailLocaleContent>;
  draft: Record<string, IEmailLocaleContent>;
}

export interface ISaveEmailDraftPayload {
  locale: string;
  content: IEmailLocaleContent;
}

export interface IPublishEmailPayload {
  locales: string[];
}

export interface ITranslateEmailPayload {
  sourceLocale: string;
  targetLocales: string[];
}

export interface IPreviewEmailPayload {
  locale: string;
  data?: Record<string, unknown>;
  draft?: boolean;
  content?: IEmailLocaleContent;
}

export interface IEmailPreviewResult {
  subject: string;
  html: string;
}
